<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">Visit info</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>
<div modalContent class="modal-body">
  <div class="row mb-2">
    <div class="stats-boxes">
      <div class="statbox statbox-primary">
        <div class="lead">Last visited</div>
        <h1 class="text-center">{{ lastVisited }}</h1>
      </div>

      <div class="statbox statbox-secondary">
        <div class="lead">Total visits</div>
        <h1 class="text-center">{{ customer.totalVisits }}</h1>
      </div>

      <div class="statbox statbox-danger">
        <div class="lead">Average wait</div>
        <h1 class="text-center">{{ avgWait | trTimeDelta }}</h1>
      </div>
    </div>
  </div>
  <div class="row d-flex" id="visit-table" *ngIf="customer.visits.length > 0">
    <div class="col-12 form-group">
      <table class="table table-striped tr-table">
        <thead>
          <tr>
            <th>Visit Date</th>
            <th>Size</th>
            <th>Wait</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let visit of customer.visits">
            <td>{{ visit.seated_time | trDateFormat:'M/D/yy h:mm a': timezone }}</td>
            <td>{{ visit.size }}</td>
            <td>{{ (visit.seated_time - visit.checkin_time) | trTimeDelta }}</td>
            <td>
              <div *ngIf="visit.type === partyTypes.reservation">{{ reservationLabel | titlecase }}</div>
              <div *ngIf="visit.type !== partyTypes.reservation">{{ numberPartyTypeToStringMap[visit.type] | titlecase }}</div>
              {{ formatNote(visit.note) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div modalFooter class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
</div>
